// extracted by mini-css-extract-plugin
module.exports = {"sellAnotherCar":"_4YiF9","sellAnotherCardWrapper":"_1zv-9","cardDetails":"RD2b5","bannerWrapper":"_1LAs6"};